<template>
  <div>
    <Head title="Reportes" />
    <h1 class="mb-8 text-3xl font-bold">Reportes</h1>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
  },
  layout: Layout,
}
</script>
